import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export type PhysicianAddress = ApiSchemas['PhysicianAddressPresenter']

export type PhysicianAddressAttendanceChannel = PhysicianAddress['attendanceChannels'][number]

export type PaymentMethod = PhysicianAddress['paymentMethods'][number]

export default {
  async get(id: number) {
    return wrapEndpoint(() =>
      client.GET('/physician-address/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
  async list(options?: ApiSchemas['ListPhysicianAddressDto']) {
    return wrapEndpoint(() =>
      client.GET('/physician-address', {
        params: {
          query: options,
        },
      }),
    )
  },
  async create(body: ApiSchemas['CreatePhysicianAddressDto']) {
    return wrapEndpoint(() =>
      client.POST('/physician-address', {
        body,
      }),
    )
  },
  async update(id: number, body: ApiSchemas['UpdatePhysicianAddressDto']) {
    return wrapEndpoint(() =>
      client.PUT('/physician-address/{id}', {
        params: {
          path: {
            id,
          },
        },
        body,
      }),
    )
  },
  async delete(id: number) {
    await wrapEndpoint(() =>
      client.DELETE('/physician-address/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
}
